/* eslint-disable import/extensions */
import { i18n } from '@lingui/core'
import { en, de, fr } from 'make-plural/plurals'

// eslint-disable-next-line import/prefer-default-export
import { wrapRootElement } from './src/contexts/wrap-root-element'
import { wrapPageElement } from './src/contexts/wrap-page-element'

i18n.loadLocaleData({
  en: { plurals: en },
  de: { plurals: de },
  fr: { plurals: fr },
})

export { wrapPageElement, wrapRootElement }

export const onInitialClientRender = () => {
  if (process.env.GATSBY_MOCK_ACCOUNTING || window.Cypress) {
    console.log(
      'Mock service worker because of GATSBY_MOCK_ACCOUNTING',
      process.env.GATSBY_MOCK_ACCOUNTING,
      'or cypress',
      window.Cypress
    )
    import('./src/mocks/browser').then(({ worker }) => worker.start())
    console.log('Registered service worker')
  }
}

export const onClientEntry = () => {
  // Timezone polyfill for IE11
  try {
    new Intl.DateTimeFormat('de-CH', {
      timeZone: 'Europe/Zurich',
      timeZoneName: 'long',
    }).format()
  } catch (e) {
    import(
      'date-time-format-timezone/build/browserified/date-time-format-timezone-no-data-min'
    )
    import(
      'date-time-format-timezone/build/browserified/data/timezones/tzdata-europe-busingen.js'
    )
    import(
      'date-time-format-timezone/build/browserified/data/timezones/tzdata-america-new_york.js'
    )

    // eslint-disable-next-line no-console
    console.log('# TimeZone is polyfilled!')
  }
}
